<script>
export default {
  name: 'UiBadge',
  props: {
    label: {
      type: String,
      required: false
    },
    type: {
      type: String,
      required: false,
      default: 'primary',
      validator(value) {
        return ['primary', 'secondary', 'success', 'info', 'warning', 'danger'].includes(value)
      }
    }
  }
}
</script>

<template>
  <span :class="['UiBadge', type]">{{ label }}<slot></slot></span>
</template>

<style lang="scss">
  .UiBadge {
    display: inline-block;
    white-space: nowrap;
    vertical-align: middle;
    padding: 2px .5em;
    text-transform: uppercase;
    border-radius: var(--radius-md);
    font-weight: 600;
    font-size: var(--text-xs);
    letter-spacing: .067em;

    &.primary {
      background-color: var(--colors-brand);
      color: var(--colors-blackalpha-900);
    }

    &.secondary {
      background-color: var(--colors-gray-200);
      color: var(--colors-gray-700);
    }

    &.success {
      background-color: var(--colors-success-200);
      color: var(--colors-success-700);
    }

    &.info {
      background-color: var(--colors-info-200);
      color: var(--colors-info-700);
    }

    &.warning {
      background-color: var(--colors-warning-200);
      color: var(--colors-warning-700);
    }

    &.danger {
      background-color: var(--colors-danger-200);
      color: var(--colors-danger-700);
    }
  }
</style>